import React from 'react';

export const AIStudio: React.FC = () => {
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-6">AI Studio</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Create your own AI-powered vocal performances.</p>
      </div>
    </div>
  );
};